import React, { FC } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { User as UserContextType } from '../../../context/AuthContext';

interface ProfileDataProps {
  user: UserContextType;
}

const ProfileData: FC<ProfileDataProps> = ({ user }) => {
  return (
    <>
      {/* Coluna 1 */}
      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Email</Typography>
          <Typography variant="body1">
            {user.email}
          </Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Telefone</Typography>
          <Typography variant="body1">
            {/* Se user.phone_number estiver indefinido, mostra "Não informado" */}
            {user.phone_number ?? 'Não informado'}
          </Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">CPF</Typography>
          <Typography variant="body1">
            {user.cpf ?? 'Não informado'}
          </Typography>
        </Box>
      </Grid>

      {/* Coluna 2 */}
      <Grid item xs={12} md={6}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Ativo</Typography>
          <Typography variant="body1">
            {user.is_active ? 'Sim' : 'Não'}
          </Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Último Login</Typography>
          <Typography variant="body1">
            {user.last_login ? new Date(user.last_login).toLocaleString() : '—'}
          </Typography>
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2">Criado em</Typography>
          <Typography variant="body1">
            {new Date(user.created_at).toLocaleString()}
          </Typography>
        </Box>
      </Grid>

      {/* Você pode adicionar mais colunas/linhas aqui, por exemplo sistemas e entidades */}
      {/* Exemplo rápido */}
      <Grid item xs={12} md={12} sx={{ mt: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Sistemas com acesso
        </Typography>
        {user.systems?.length ? (
          user.systems.map((sys) => (
            <Box
              key={sys.id}
              sx={{
                p: 1,
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1,
                mb: 1,
              }}
            >
              <Typography variant="body1">
                <strong>Nome:</strong> {sys.name}
              </Typography>
              <Typography variant="body2">
                <strong>Base URL:</strong> {sys.base_url}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            Nenhum sistema associado.
          </Typography>
        )}
      </Grid>
    </>
  );
};

export default ProfileData;